import { Modal } from 'antd'

interface AiAgentIntroModalProps {
  open: boolean
  onClose: () => void
}

function AiAgentIntroModal({ open, onClose }: AiAgentIntroModalProps) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={720}
      className='ai-agent-intro-modal'
      title='Welcome to Ask AL'
      destroyOnClose
    >
      <div className='ai-agent-consent-content'>
        <p>
          Learn how Ask AL helps you summarise and compare policies faster. This short intro
          explains key features and best practices.
        </p>
        <div className='ai-agent-intro-video'>
          <iframe
            title='Introduction to PolicyComparison AL bot'
            src='https://www.youtube.com/embed/JMt9bKiOikU?rel=0&modestbranding=0&disablekb=0&playsinline=1'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            allowFullScreen
          />
        </div>
      </div>
    </Modal>
  )
}

export { AiAgentIntroModal }
